import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoviesinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("rect", {
				strokeLinecap: "square",
				x: 5,
				y: 25,
				width: 42,
				height: 24,
				rx: 4
			}),
			/* @__PURE__ */ _jsx("path", { d: "M47 34.33l12-10.853v26.046L47 38.67" }),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 31.5,
				cy: 11.5,
				r: 9.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 15,
				cy: 14,
				r: 7
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M16 62.607L25.607 49l9.606 13.607"
			})
		]
	})
});
export default SvgMoviesinline;
